import React, {Component} from 'react'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import UserIcon from '@material-ui/icons/AccountBox'

import PaperBlock from "./../ui/PaperBlock"

import withStyles from '@material-ui/core/styles/withStyles'

/**
 * users - список пользователей.
 * selected - выбранный пользователь.
 * filter - фильтр permission для показа.
 * 
 * onUserClick(user)
 * onUserDoubleClick(user)
 */

class UsersList extends Component {

	getPermissionName(value) {
		switch (value) {
			case 1: return "Ожидает подтверждения"
			case 2: return "Администратор"
			case 3: return "Работник"
			case 4: return "Ведущий"
			default: return "Никто"
		}
	}

	getUserIconClass(user) {
		switch (user.permission) {
			case 2: return this.props.classes.adminIcon
			case 3: return this.props.classes.workerIcon
			case 4: return this.props.classes.artistIcon
			default: return this.props.classes.nobodyIcon
		}
	}

	userInFilter(user, filters) {
		return filters ? filters.find(filter => filter === user.permission) != undefined : true
	}

	render() {
		return <PaperBlock style={this.props.widthFix ? {width: "auto"} : {}}>
			<List>
				{this.props.users.map((user, n) => (this.userInFilter(user, this.props.filter) && user.id != 1) && <ListItem
					key = {n}
					button
					selected = {this.props.selected ? this.props.selected.id === user.id : false}
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUserClick === "function") {
							this.props.onUserClick(user)
						}
					}}
					onDoubleClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onUserDoubleClick === "function") {
							this.props.onUserDoubleClick(user)
						}
					}}
				>
					<ListItemIcon>
						<UserIcon className = {this.getUserIconClass(user)} />
					</ListItemIcon>
					<ListItemText
						primary = {user.name}
						secondary = {this.getPermissionName(user.permission)}
					/>
				</ListItem>)}
			</List>
		</PaperBlock>
	}
}

export default withStyles(theme => ({
	nobodyIcon: {fill: "green"},
	adminIcon: {fill: "red"},
	workerIcon: {fill: "blue"},
	artistIcon: {fill: "orange"},
}))(UsersList)
